<div class="stats-card-wrapper">
  <div
    class="stats-card"
    [class.primary]="variant === 'primary'"
    [class.golden]="variant === 'golden'"
  >
    <div class="stats-value">{{ value }}</div>
  </div>

  <div class="stats-label">{{ label }}</div>
</div>
